import auth from '@feathersjs/authentication-client'
import feathers from '@feathersjs/feathers'
import rest from '@feathersjs/rest-client'
import axios from 'axios'
// import rot47 from './rot47'

export default function createAppClient(url, config) {
  const cfg = {
    authentication: {},
    extenderPath: '__serviceExtender',
  }

  const app = feathers()
    .configure(rest(url).axios(axios))
    .configure(auth(cfg.authentication))

  const extenderService = app.service(cfg.extenderPath)
  const promise = extenderService.find().then(extensions => {
    extensions.forEach(({ path, methods }) => {
      methods.forEach(method => {
        app.service(path)[method] = (data, params) => {
          const body = { path, method, data }
          // url.indexOf('localhost') === -1 && url.indexOf('47.94.156.98') === -1
          //   ? { path: rot47(path), method: rot47(method), data: data ? rot47(JSON.stringify(data)) : data }
          //   : { path, method, data }
          return extenderService.create(body, params)
        }
      })
    })
    return extensions
  })
  app.set('serviceExtensions', promise)
  return app
}
